import { VisuallyHidden } from '@reach/visually-hidden'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { translate } from '@/utils/translations'

const Email = ({ isbns, url }) => {
  const title = useSelector(state => state.asset.title)
  const subject = encodeURI(translate('purchase.check_out_this_e_book'))
  const body = encodeURIComponent(`
    ${translate('common.title')}: ${title}
    ISBNs: ${isbns}
    URL: ${url}`
  )

  return (
    <li>
      <a
        className='email'
        href={`mailto:?subject=${subject}&body=${body}`}
        rel='noopener noreferrer'
        target='_blank'
      >
        <p>{translate('common.email')}</p>
        <VisuallyHidden>
          {translate('purchase.share_this_ebook_with_email')}
        </VisuallyHidden>
      </a>
    </li>
  )
}

export default Email

Email.propTypes = { isbns: PropTypes.string, url: PropTypes.string.isRequired }
